<template>
    <div id="app">
        <header class="header" :class="`header--${currentView}`">
            <a href="/">
                <smash-logo class="header__logo" />
            </a>
        </header>
        <viz class="app__viz"></viz>
        <scroller class="app__scroller"></scroller>
    </div>
</template>

<script>
import Scroller from './components/Scroller'
import Viz from './components/Viz'
import SmashLogo from './components/SmashDeltaLabsLogo'

import { mapState } from 'vuex'

export default {
    name: 'app',
    components: {
        Scroller,
        Viz,
        SmashLogo,
    },
    computed: {
        ...mapState(['currentView']),
    },
    mounted() {
        // Scroll to top on refresh
        // Useful for testing, helps fix some bugs in production too
        window.onbeforeunload = function() {
            window.scrollTo(0, 0)
        }

        // // Manually call page event for google analytics.
        // // Done after a timeout to allow a tracker to be initialised.
        // // Probably not ideal
        // let ga = this.$ga
        // setTimeout(function () {
        //   ga.page('/smartcities')
        // }, 500)
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoepd>
.app__viz {
    position: fixed;
    height: calc(100vh - 82px);
    width: 70vw;
    left: 30vw;
    right: 0;
    top: 82px;
    bottom: 0;
}

.header {
    position: fixed;
    width: 100vw;
    height: 82px;
    top: 0;
    left: 0;
    right: 0;
    border-bottom: 1px solid white;
    background-color: #eae4e4;
    transition: opacity 1s;
    opacity: 1;
    z-index: 10;
}
.header--landing {
    opacity: 0;
}

.header__logo {
    width: 130px;
    height: 82px;
}

@media (min-width: 1600px) {
    .header__logo {
        margin-left: calc(10vw - 17px);
    }
}
</style>
